import { IEvent } from "@quest/adapter-interface";
import { Container, dispatcher, ingenuity, SpineBase } from "@quest/base-core";
import { JackpotBannerBackgroundView } from "./JackpotBannerBackgroundView";
import { eventDispatchers } from "../Constants/EventDispatchers";

/**
 * BackgroundControllerGame class manages the background elements and visuals
 * within the game, providing functionality for dynamic updates, transitions,
 * and interactions related to the game's background.
 *
 * This class serves as a controller to handle background-related logic,
 * enhancing the overall gaming experience by seamlessly integrating and
 * controlling background elements in response to game events.
 */
export class JackpotBannerBackgroundController {
  private JackpotBgContainer: Container;
  private JackpotBgSpine:SpineBase;
  private youWonBgSpine:SpineBase;
  private youWonBgSpineContainer: Container;
  private youWonBGPortrait:SpineBase;
  private jackpotBackgroundPortrait: SpineBase;
  private view : JackpotBannerBackgroundView;
  private introSpineBGPortrait: SpineBase;
  private introSpineBG: SpineBase;
  private bonusIntroContainer:Container;

  constructor(viewJson:JackpotBannerBackgroundView){
    this.view = viewJson;
    this.subscribeEvents();
    this.initializeElements();
  }
  private initializeElements(): void {
    this.JackpotBgContainer = this.view.getContainerByID("JackpotBgContainer");
      this.bonusIntroContainer = this.view.getContainerByID("IntroBGContainer");
    this.youWonBgSpineContainer = this.view.getContainerByID("youWonBgSpineContainer");
    this.JackpotBgSpine = this.view.getSpineById("jackpot_background");
    this.youWonBgSpine = this.view.getSpineById("you_wonBG");
        this.introSpineBG = this.view.getSpineById("bonusIntroBg") as SpineBase;
    !ingenuity.deviceEnv.isDesktop && this.initializePortraitElements();
  }

  private initializePortraitElements(): void {
    this.jackpotBackgroundPortrait = this.view.getSpineById("jackpot_background_portrait");
    this.youWonBGPortrait = this.view.getSpineById("you_wonBGPortrait");
    this.introSpineBGPortrait = this.view.getSpineById("bonusIntroBgPortrait") as SpineBase;
}

private subscribeEvents(): void {
    this.unsubscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_JACKPOT_BG,this.showJackpotBg,this);
    dispatcher.on(eventDispatchers.SHOW_YOU_WON_BG,this.showYouWonBg,this);
 dispatcher.on(eventDispatchers.SHOW_INTRO_BG,this.playIntroSpine,this);

  }

private unsubscribeEvents(): void {
    dispatcher.off(eventDispatchers.SHOW_JACKPOT_BG,this.showJackpotBg,this);
    dispatcher.off(eventDispatchers.SHOW_YOU_WON_BG,this.showYouWonBg,this);
 dispatcher.off(eventDispatchers.SHOW_INTRO_BG,this.playIntroSpine,this);
  }

    /**
   * play intro spine
   */
  private playIntroSpine(evt:IEvent): void {
      let action = evt.data.action;
    let ifLoop : boolean = false;
    if(action == 'loop'){
        ifLoop = true;
    } else {
        ifLoop = false;
    }
    this.bonusIntroContainer.visible = true;
    this.introSpineBG.visible = true;
    this.introSpineBG.playAnim(`background_desktop_${action}`,ifLoop);
    if(action == 'out'){
        this.introSpineBG.visible = false;
        this.bonusIntroContainer.visible = false;
    }
     !ingenuity.deviceEnv.isDesktop && this.showBonusIntroBgPortrait(action);
  }

  private showBonusIntroBgPortrait(action:string):void{
    let ifLoop : boolean = false;
    if(action == 'loop'){
        ifLoop = true;
    } else {
        ifLoop = false;
    }
    this.bonusIntroContainer.visible = true;
    this.introSpineBGPortrait.visible = true;
    this.introSpineBGPortrait.playAnim(`background_portrait_${action}`,ifLoop);
    if(action == 'out'){
        this.introSpineBGPortrait.visible = false;
        this.bonusIntroContainer.visible = false;
    }
  }

  private showJackpotBg(evt:IEvent){
    let action = evt.data.action;
    let ifLoop : boolean = false;
    if(action == 'idle'){
        ifLoop = true;
    } else {
        ifLoop = false;
    }
    this.JackpotBgContainer.visible = true;
    this.JackpotBgSpine.visible = true;
    this.JackpotBgSpine.playAnim(`jackpot_${action}_bg_desktop`,ifLoop);
    if(action == 'outro'){
        this.JackpotBgSpine.visible = false;
        this.JackpotBgContainer.visible = false;
    }
     !ingenuity.deviceEnv.isDesktop && this.showJackpotBgPortrait(action);
  }

  private showJackpotBgPortrait(action:string){
    let ifLoop : boolean = false;
    if(action == 'idle'){
        ifLoop = true;
    } else {
        ifLoop = false;
    }
    this.JackpotBgContainer.visible = true;
    this.jackpotBackgroundPortrait.visible = true;
    this.jackpotBackgroundPortrait.playAnim(`jackpot_${action}_bg_portrait`,ifLoop);
    if(action == 'outro'){
        this.jackpotBackgroundPortrait.visible = false;
        this.JackpotBgContainer.visible = false;
    }
  }

  private showYouWonBg(evt:IEvent){
    let action = evt.data.action;
    let ifLoop : boolean = false;
    if(action == 'loop'){
        ifLoop = true;
    } else {
        ifLoop = false;
    }
    this.youWonBgSpineContainer.visible = true;
    this.youWonBgSpine.visible = true;
    this.youWonBgSpine.playAnim(`${action}_desktop`,ifLoop);
    if(action == 'out'){
        this.youWonBgSpine.visible = false;
        this.youWonBgSpineContainer.visible = false;
    }
     !ingenuity.deviceEnv.isDesktop && this.showYouWonBgPortrait(action);
  }

  private showYouWonBgPortrait(action:string){
    let ifLoop : boolean = false;
    if(action == 'loop'){
        ifLoop = true;
    } else {
        ifLoop = false;
    }
    this.youWonBgSpineContainer.visible = true;
    this.youWonBGPortrait.visible = true;
    this.youWonBGPortrait.playAnim(`${action}_portrait`,ifLoop);
    if(action == 'out'){
        this.youWonBGPortrait.visible = false;
        this.youWonBgSpineContainer.visible = false;
    }
  }
}
